<!-- =========================================================================================
  File Name: ChartjsComponentBarChart.vue
  Description: Chartjs component - Bar Chart
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<script>
import { Bar } from 'vue-chartjs'

// eslint-disable-next-line no-unused-vars
export default {
  extends: Bar,
  data () {
    return {
      data: {
        labels:[],
        datasets: [
          {
            label: '',
            backgroundColor: [],
            data:[]
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: ''
        }
      }
    }
  },
  mounted () {
    this.$http.get('dashboardAdminClient/')
      .then((response) => {
        if (response.data.letters_stats && response.data.letters_stats.letters_by_month) {
        // Clés du backend
          const months = [
            'month_1', 'month_2', 'month_3', 'month_4', 'month_5', 'month_6',
            'month_7', 'month_8', 'month_9', 'month_10', 'month_11', 'month_12'
          ]

          // Labels affichés
          const monthLabels = [
            'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
            'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
          ]

          // Mois courant (de 1 à 12)
          const currentMonthNumber = new Date().getMonth() + 1

          // Extraire uniquement jusqu’au mois courant
          const visibleLabels = monthLabels.slice(0, currentMonthNumber)
          const visibleMonths = months.slice(0, currentMonthNumber)

          // Appliquer au graphique
          this.data.labels = visibleLabels
          this.data.datasets = [
            {
              label: 'Lettres par mois',
              backgroundColor: '#2A7B9B',
              borderColor: '#2A7B9B',
              data: visibleMonths.map(m => response.data.letters_stats.letters_by_month[m] || 0)
            }
          ]
        }

        this.renderChart(this.data, this.options)
      })
  }

}
</script>
